import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CustomizedTaskFormView } from 'app/models/form/task-management/CustomizedTaskFormView';
import { BaseFormService } from 'app/services/BaseFormService';
import { UtilityService } from 'app/services/utility.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class CustomizedTaskFormService extends BaseFormService {
	constructor(httpClient: HttpClient, utilityService: UtilityService) {
		super(`${environment.apiUrl}forms/clients/$$clientId$$/customized-task-form`, httpClient, utilityService);
	}

	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.getUrl(clientId)}/${id}/approval`, {
				userId,
			})
			.pipe();
	}
	submitDeliverables(clientId: string, formId: string, request: any): Observable<CustomizedTaskFormView> {
		const formData: FormData = new FormData();
		for (let i = 0; i < request.deliverables.length; i++) {
			const name = `deliverable-${i + 1}`;
			formData.append(name, request.deliverables[i].file);
			request.deliverables[i].file = null;
			request.deliverables[i].name = name;
		}

		formData.append('model', JSON.stringify(request));

		return this.httpClient
			.post<CustomizedTaskFormView>(`${this.getUrl(clientId)}/${formId}/deliverables`, formData)
			.pipe();
	}
	cancelSchedule(id: string, clientId: string): Observable<CustomizedTaskFormView> {
		return this.httpClient.delete<CustomizedTaskFormView>(`${this.getUrl(clientId)}/${id}/cancelSchedule`).pipe();
	}

	getCustomizedTaskFormsForScheduling(clientId: string, data: any): Observable<CustomizedTaskFormView[]> {
		return this.httpClient.post<CustomizedTaskFormView[]>(`${this.getUrl(clientId)}/manage/scheduling`, data).pipe();
	}

	updateCustomizedTaskFormForScheduling(clientId: string, message: any): Observable<CustomizedTaskFormView[]> {
		return this.httpClient
			.post<CustomizedTaskFormView[]>(`${this.getUrl(clientId)}/manage/scheduling/update`, message)
			.pipe();
	}
}
